import request from '@/utils/request'
import { toCmsContent, mapPageResult, mapSingleResult } from './helpers'

export function getAlumnus (params) {
  // 有搜索关键词时使用搜索接口，否则使用列表接口
  const endpoint = params && params.keyword ? '/api/cms/search' : '/api/cms/list'
  return request.get(endpoint, {
    params: { ...params, type: 'FACULTY' }
  }).then(mapPageResult)
}

// 注意：新后端没有独立的 position 列表接口
// 返回空数组，前端筛选栏不会显示
export function getPositionList () {
  return Promise.resolve({ code: 1, data: [] })
}

export function getAlumnusDetail (id) {
  return request.get(`/api/cms/detail/${id}`).then(mapSingleResult)
}

export function addAlumnus (data) {
  return request.post('/api/cms', toCmsContent(data, 'FACULTY'))
}

export function updateAlumnus (data) {
  return request.put(`/api/cms/${data.id}`, toCmsContent(data, 'FACULTY'))
}

export function deleteAlumnus (id) {
  return request.delete(`/api/cms/${id}`)
}
